<div class="flex-grow-1">
  <p-autoComplete [suggestions]="members"
                  (completeMethod)="completeMethod($event)"
                  (onSelect)="onSelect($event.value)"
                  [minLength]="1"
                  [autoZIndex]="true"
                  [required]="true"
                  [unique]="true"
                  [forceSelection]="true"
                  scrollHeight="20vw"
                  appendTo="body"
                  placeholder="Enter email, ORCID iD or full name"
                  i18n-placeholder
                  dataKey="memberId"
                  optionLabel="null"
                  [showEmptyMessage]="true"
                  [emptyMessage]="emptyMessage"
                  class="w-full">
    <ng-template let-member
                 pTemplate="item">
      <div class="flex flex-row">
        <div class="flex flex-column">
          <span class="font-bold mb-2">{{ member.firstName }} {{ member.lastName }}</span>
          <span class="et-primary-email mb-2">{{ member.email }}</span>
          @if (member?.authorEmails?.length) {
            @for (email of member.authorEmails; track email) {
              <small class="et-author-email mb-2">
                {{ email }}
              </small>
            }
          }

          @if (member?.countryName; as countryName) {
            <div>
              {{ countryName }}
            </div>
          }

          @if (member.universityOrOrganization; as universityOrOrganization) {
            <div>
              <div class="white-space-normal">{{ universityOrOrganization }}</div>
            </div>
          }

          @if (member.orcidId; as orcidId) {
            <div>
              {{ orcidId }}
            </div>
          }

        </div>
      </div>
    </ng-template>
  </p-autoComplete>
</div>